<template>
    <div class="card mb-3" style="min-height: 60vh;">
        <a-drawer v-if="account != null" :visible="showDrawerViewDetails" :width="480" placement="right" @close="onClose">
            <h6 class="heading-small text-muted">Account Custom Profile</h6>
            <br>
            <div  class="col-xl-12 col-lg-12">
                <div class="col-md-12" style="border-left: 1px solid #e0e0e0; max-height: 80vh; overflow-y: scroll;"> 
                    
                    <stats-card :title="account.company_name"
                        type="gradient-green"
                        :sub-title="`Unique Fields per profile`"
                        icon="ni ni-building"
                        class="mb-4 mb-xl-0">
                        <template slot="footer">

                            <span class="mr-2"> Account: {{account.account_name}} </span>
                        </template>
                    </stats-card>

                    <br><br>
                    <div v-if="treeData.length == 0 || treeData === undefined">
                        <span class="mr-2"> No Custom Profile for your account yet.</span><br><br>
                        <button type="button" class="btn btn-sm btn-success float-left" style="width: 50%" @click.prevent="create()">Initialize Custom Profile</button> 
                    </div>
                    <a-tree
                        v-if="treeData.length != 0"
                        v-model="checkedKeys"
                        checkable
                        :expanded-keys="expandedKeys"
                        :auto-expand-parent="autoExpandParent"
                        :selected-keys="selectedKeys"
                        :tree-data="treeData"
                        @expand="onExpand"
                        @select="onSelect"
                    />
                </div>
            </div>
            
            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button type="button" v-if="viewOnly == false" class="btn btn-sm btn-success float-right mr-2" style="width: 20%" @click.prevent="update()">Save</button> 
                <button type="button" class="btn btn-sm float-right mr-2" style="width: 20%" @click.prevent="closeAccountDetails()">Back</button> 
                <button type="button" v-if="viewOnly == false" class="btn btn-sm btn-warning float-right mr-2" style="width: 20%" @click.prevent="syncProfile()">Sync</button> 
                <button type="button" v-if="viewOnly == false" class="btn btn-sm btn-danger float-right mr-2" style="width: 23%" @click.prevent="resetProfile()">Reset Profile</button> 
            </div>
    
        </a-drawer>
        
        <div style="min-height: 60vh;">
          <div class="card-body">
            <div class="row">
                <div class="col-md-10"><h2>Account List</h2></div>
                <div class="table-responsive" >
                    <vuetable  ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" 
                    :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
                    @vuetable:load-error="onLoadError" 
                    @vuetable:pagination-data="onPaginationData">
            
                    <template slot="actions" slot-scope="props">
                        <!-- {{props}} -->
                    <!-- <template slot="actions"> -->
                      <center>
                        <a-button :loading="loading" class="btn btn-success btn-sm" @click.prevent="showAccountDetails(props.rowData.id, true)">View Profile</a-button>&nbsp;&nbsp;
                        <a-button :loading="loading" class="btn btn-warning btn-sm" @click.prevent="showAccountDetails(props.rowData.id, false)">Edit</a-button>&nbsp;&nbsp;
                      </center>
                    </template>
            
                  </vuetable>
                </div>
                
                <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
                  <div class="pagination ui basic segment grid">
                    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
                    </vuetable-pagination>
                  </div>
                </div>

            </div>
          </div>
        </div>
    </div>
</template>

<script>
import ValidateField from '../../components/validateFormUtils.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import { mapState } from 'vuex'

var treeData = []
export default {
    components: {
        Vuetable,
        VuetablePagination
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    data () {
        return {
            activeKey: "1",
            account: null,
            type: "dark",
            showDrawer: false,
            showDrawerViewDetails: false,
            accountName: null,
            companyName: null,
            firstName: null,
            lastName: null,
            contactNumber: null,
            emailAddress: null,
            password: null,
            emailAddressConfirmation: null,
            passwordConfirmation: null,
            companyAddress: null,
            companyTinNumber: null,
            viewOnly: true,
            // accountName: "mikee",
            // companyName: "Mikee Inc",
            // firstName: "Mikee",
            // lastName: "Tanqueco",
            // contactNumber: "09175774714",
            // emailAddress: "mikee@imonggo.com",
            // password: "password",
            // emailAddressConfirmation: "mikee@imonggo.com",
            // passwordConfirmation: "password",
            // companyAddress: "Malolos Bulacan",
            // companyTinNumber: "111111",
            fields: [{name: "account_name", title: "Account Name"}, 
                  {name: "company_name", title: "Company Name"}, 
                  '__slot:actions'],
            httpOptions: {
              headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
              }
            },
            apiURL: "",
            css: {
              table: {
                tableClass: 'table table-sm table-striped table-bordered table-hovered',
                loadingClass: 'loading'
              },
              pagination: {
                infoClass: 'pull-right',
                wrapperClass: 'vuetable-pagination pull-right',
                activeClass: 'btn-primary btn-sm',
                disabledClass: 'disabled',
                pageClass: 'btn btn-border',
                linkClass: 'btn btn-border',
                icons: {
                  first: '',
                  prev: '',
                  next: '',
                  last: '',
                },
              }
            },
            errors: [],
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            treeData,
            loading: false,
            allKeys: [],
            pufId: null
        }
    },
    mounted: function () {
        this.apiURL = this.endPoint + "/accounts"

    },
    watch: {
        checkedKeys(val) {
            console.log('onCheck', val);
        }
    },
    methods: {
        onClose(){
            this.showDrawer = false
            this.checkedKeys = []
            this.loading =  false
            this.showDrawerViewDetails = false
        },
        async onLoadError(error) {
            console.log(error)
        },
        async onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        async showAccountDetails(id, vm){
            this.loading = true
            this.viewOnly = vm
            var accountRequest = await HTTPRequest.getRequest(this.endPoint + '/accounts/' + id, null, null)  
            var treeBreakdown = await HTTPRequest.getRequest(this.endPoint + '/profile_unique_fields/?account_id=' + id  , null)
            var res = [];
            if(treeBreakdown.data[0] != undefined){
                var obj = treeBreakdown.data[0].json_settings;
                this.pufId = treeBreakdown.data[0].id;
                for(var i in obj){
                    var profile_fields = []
                    if(i == "documents"){
                        // loop through document types
                        for(var j in obj[i]){
                            var subprofile_fields = []
                            for(var k in obj[i][j]){
                                subprofile_fields.push({title: k, key: `${i}||${j}||${k}`, disabled: vm, checkable: true})
                                if(obj[i][j][k]){
                                    this.checkedKeys.push(`${i}||${j}||${k}`)
                                }
                            }
                            profile_fields.push({title: j, key: `${i}||${j}`, children: subprofile_fields, disabled: vm, checkable: false})
                        }
                    }
                    else{
                        for(var j in obj[i]){
                            profile_fields.push({title: j, key: `${i}||${j}`, disabled: vm, checkable: true})
                            if(obj[i][j]){
                                this.checkedKeys.push(`${i}||${j}`)
                            }
                        }
                    }
                    res.push({title: i, key: i, children: profile_fields, disabled: vm, checkable: false})
                }
            }            
            this.treeData = res
            this.account = accountRequest
            this.showDrawerViewDetails = true
        },
        async closeAccountDetails(){
            this.checkedKeys = []
            this.loading = false
            this.showDrawerViewDetails = false
        },
        onExpand(expandedKeys) {
            console.log('onExpand', expandedKeys);
            // if not set autoExpandParent to false, if children expanded, parent can not collapse.
            // or, you can remove all expanded children keys.
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        onCheck(checkedKeys) {
            console.log('onCheck', checkedKeys);
            this.checkedKeys = checkedKeys;
        },
        onSelect(selectedKeys, info) {
            console.log('onSelect', info);
            this.selectedKeys = selectedKeys;
        },
        create: async function(){
            var PUFPayload = {profile_unique_fields: {status: "A", account_id: this.account.id}}

            var post_request = await HTTPRequest.postRequest(this.endPoint + 'profile_unique_fields/', null, PUFPayload) 
            
            if(post_request.error != undefined){
                this.$notification['error']({
                  message: 'Error in initializing custom profile.',
                  description: post_request.error
                });
            }else{
                this.$notification['success']({
                    message: 'Successfully created profile.'
                });    
            }
            this.checkedKeys = []
            this.loading = false
            this.showDrawerViewDetails = false
        },
        resetProfile: async function(){
            var put_request = await HTTPRequest.putRequest(this.endPoint + 'profile_unique_fields/reset/?account_id='+this.account.id, null, {}) 
            
            if(put_request.error != undefined){
                this.$notification['error']({
                  message: 'Error in resetting custom profile.',
                  description: put_request.error
                });
            }else{
                this.$notification['success']({
                    message: 'Successfully reset profile.'
                });    
            }
            this.checkedKeys = []
            this.loading = false
            this.showDrawerViewDetails = false
        },

        syncProfile: async function(){
            var put_request = await HTTPRequest.putRequest(this.endPoint + 'profile_unique_fields/sync_to_initial_settings/?account_id='+this.account.id, null, {}) 
            if(put_request.error != undefined){
                this.$notification['error']({
                  message: 'Error in syncing custom profile.',
                  description: put_request.error
                });
            }else{
                this.$notification['success']({
                    message: 'Successfully synced profile to latest initial setting.'
                });    
            }
            this.checkedKeys = []
            this.loading = false
            this.showDrawerViewDetails = false
        },
        update: async function(){
            var profile_fields = {}
            for(var i in this.treeData){
                profile_fields[this.treeData[i].key] = {}
                for(var j in this.treeData[i].children){
                    console.log("is j checkable");
                    console.log(j);
                    console.log(j.checkable);
                    if(this.treeData[i].children[j].checkable){
                        if(this.checkedKeys.includes(`${this.treeData[i].children[j].key}`)){
                            profile_fields[this.treeData[i].key][this.treeData[i].children[j].title] = true
                        }else{
                            profile_fields[this.treeData[i].key][this.treeData[i].children[j].title] = false
                        }
                    }else{
                        profile_fields[this.treeData[i].key][this.treeData[i].children[j].title] = {}
                        for(var k in this.treeData[i].children[j].children){
                            if(this.checkedKeys.includes(`${this.treeData[i].children[j].children[k].key}`)){
                                profile_fields[this.treeData[i].key][this.treeData[i].children[j].title][this.treeData[i].children[j].children[k].title] = true
                            }else{
                                profile_fields[this.treeData[i].key][this.treeData[i].children[j].title][this.treeData[i].children[j].children[k].title] = false
                            }
                        }
                    }
                }
            }
            var PUFPayload = {profile_unique_fields: {json_settings: profile_fields}}
            var put_request = await HTTPRequest.putRequest(this.endPoint + 'profile_unique_fields/' + this.pufId, null, PUFPayload) 
            
            if(put_request.error != undefined){
                this.$notification['error']({
                  message: 'Error in updating custom profile.',
                  description: put_request.error
                });
            }else{
                this.$notification['success']({
                    message: 'Successfully updated profile.'
                });    
            }
            this.checkedKeys = []
            this.loading = false
            this.showDrawerViewDetails = false
        },
    }
}

</script>

<style>

.ant-collapse > .ant-collapse-item-active > .ant-collapse-header {
  background-color: #32325d;
  color: white;
}

</style>


